@if (value) {
    <div class="coordinate-editor" [class.coordinate-editor--compact]="compact()">
        @if (!showUrlParser) {
            <mat-form-field class="coordinate-editor__field w-full" [class.frosty]="compact()">
                <mat-label>{{ 'SystemAdmin.Components.CoordinateEditor.Label.Latitude' | translate }}</mat-label>
                <mat-icon matPrefix class="coordinate-editor__prefix icon-size-5" [svgIcon]="'fal:location-dot'"></mat-icon>
                <input
                    matInput
                    name="latitude"
                    type="number"
                    step="0.000001"
                    #field_latitude
                    [(ngModel)]="value[0]"
                    [ngModelOptions]="{ standalone: true }"
                    [placeholder]="'SystemAdmin.Components.CoordinateEditor.Label.Latitude' | translate"
                    [spellcheck]="false">
                <mat-error>
                    <div [innerHTML]="'SystemAdmin.Common.Validation.Required' | translate"></div>
                </mat-error>
            </mat-form-field>

            <mat-form-field class="coordinate-editor__field w-full" [class.frosty]="compact()">
                <mat-label>{{ 'SystemAdmin.Components.CoordinateEditor.Label.Longitude' | translate }}</mat-label>
                <mat-icon matPrefix class="coordinate-editor__prefix icon-size-5" [svgIcon]="'fal:location-dot'"></mat-icon>
                <input
                    matInput
                    name="longitude"
                    type="number"
                    step="0.000001"
                    #field_longitude
                    [(ngModel)]="value[1]"
                    [ngModelOptions]="{ standalone: true }"
                    [placeholder]="'SystemAdmin.Components.CoordinateEditor.Label.Longitude' | translate"
                    [spellcheck]="false">
                <mat-error>
                    <div [innerHTML]="'SystemAdmin.Common.Validation.Required' | translate"></div>
                </mat-error>
            </mat-form-field>
        } @else {
            <mat-form-field
                class="coordinate-editor__field coordinate-editor__field--wide w-full"
                [class.frosty]="compact()">
                <mat-label>{{ 'SystemAdmin.Components.CoordinateEditor.ManualEntry.Label' | translate }}</mat-label>
                <mat-icon matPrefix class="coordinate-editor__prefix icon-size-5" [svgIcon]="'fal:location-dot'"></mat-icon>
                <input
                    matInput
                    type="text"
                    #field_url
                    [placeholder]="'SystemAdmin.Components.CoordinateEditor.ManualEntry.PlacelHolder' | translate"
                    [spellcheck]="false"
                    [(ngModel)]="mapUrl"
                    (input)="parseUrl()">
                <mat-error>
                    <div [innerHTML]="'SystemAdmin.Common.Validation.Required' | translate"></div>
                </mat-error>
            </mat-form-field>
        }

        <div class="coordinate-editor__action">
            <button
                type="button"
                class="coordinate-editor__mode-action"
                (click)="executeParseUrl()">
                @if (showUrlParser) {
                    <span>{{ 'SystemAdmin.Components.CoordinateEditor.CoordsManualEntry' | translate }}</span>
                } @else {
                    <span>{{ 'SystemAdmin.Components.CoordinateEditor.CoordsAutoParse' | translate }}</span>
                }
            </button>
        </div>
    </div>
}
